module.exports = __webpack_public_path__ + "img/cpu.62d629bf.png";